import { render, staticRenderFns } from "./FoundationTv.vue?vue&type=template&id=1e1237f4&scoped=true&"
import script from "./FoundationTv.vue?vue&type=script&lang=js&"
export * from "./FoundationTv.vue?vue&type=script&lang=js&"
import style0 from "./FoundationTv.vue?vue&type=style&index=0&id=1e1237f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1237f4",
  null
  
)

component.options.__file = "FoundationTv.vue"
export default component.exports